module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAQCAYAAAAiYZ4HAAAAi0lEQVQ4T2PcufeIJ8P//3MZGBkkGfCB/wzPGRgZkxl37jn8jKBimEH/GZ4z7tx7+D+Iz/SP0dbV1eYINkt27z5i84/p/2GQHFyDu7MtIz4XwQwe1UC/UIKFOXLc4I0HojTgSxq79h2y/v+fEZxsSEt8DAwvGHftO+L1H5S8GRgk8CZvBoanjIyMaQCM2n74FeS5KgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/ip.png
// module id = qUNw
// module chunks = 1